import ET from './global-helpers';
import Mustache from 'mustache';
import $ from 'jquery';
import '../vendor/jquery.sticky-kit.min';

window.jQuery = window.$ = $;

export default {
  init: function() {

    //Constants
    var PAGE_ID = $('body').data('page-id');

    /**
     * Create collapsibles
     */
    (function() {
      //Don't create collapsibles if inside Stage editor
      if($('body').is('.stage-editor')) { return; }

      var container = $('article.article .body-content, article.summary-article .body-content'),
          buttonTemplate = $('#article-button-template').html(),
          numberTemplate = $('#article-number-template').html(),
          h2s = $('h2', container).not('.divider'),
          dividers = $('h2.divider', container),
          sectionElements,
          number = 0;

      //Don't bother if there's only one h2,
      //else create collapsible sections based on h2 as the starting point
      if(h2s.length > 1 && buttonTemplate && numberTemplate) {
        //Prerender Mustache templates
        Mustache.parse(buttonTemplate);
        Mustache.parse(numberTemplate);

        //Generate sections
        $.each(h2s, function(i, h2) {
          number = i+1;
          var sectionSlug = ET.slugify($(h2).text());

          //prefix number with zero if less than 10
          /*if(number < 10) {
            number = '0' + number;
          }*/

          //Contains original h2 and all siblings until next h2
          sectionElements = $(h2).nextUntil('h2, .related-articles').addBack();

          //First element after h2 gets teaser class
          sectionElements.eq(1).addClass('teaser');

          //Create section container
          sectionElements.wrapAll('<section class="collapsible" id="collapsible-' + sectionSlug + '" tabindex="-1"></section>');
          var sectionContainer = sectionElements.parent('.collapsible');

          //Add section number
          sectionContainer.prepend(Mustache.render(numberTemplate, {number: number}));

          //Rest after teaser gets wrapped in .content
          $('.teaser', sectionContainer).nextAll().wrapAll('<div class="content"></div>');

          //Find h3.toc-heading elements in section and add id for them
          sectionContainer.find('h3.toc-heading').each(function(){
            var subHeadingSlug = sectionSlug+'_'+ET.slugify($(this).text());
            $(this).attr('id', subHeadingSlug);
          })

          //Add toggle button
          sectionContainer.append(Mustache.render(buttonTemplate));
        });

        //Generate dividers, are only visible in TOC
        $.each(dividers, function(i, h2) {
          var slug = ET.slugify($(h2).text());
          $(h2).before('<div id="divider-' + slug + '"></div>');
          $(h2).wrap('<section class="divider" data-target="divider-' + slug + '"></section>');
        });
      }

      //Collapsible section, more/less button functionality
      $('.collapsible').on('click', '.toggle-collapsible-content', function(e) {
        var that = $(this),
            parent = that.closest('.collapsible');

        parent.toggleClass('open');

        if(parent.is('.open')) {
          //Opening, should focus to first newly visible content
          parent.focus();

        }else {
          //Closing, set focus on back-to-toc
          that.parent().find('.back-to-toc').focus();

          //On close it should scroll to top of closed section
          ET.scrollTo(parent, {animate: false});

        }

        $(window).resize(); //Trigger needed for TOC to calculate new positions

      });

      //Collapsible section, back to toc button (visuallyhidden)
      $('.collapsible').on('click', '.back-to-toc', function(e) {
        var that = $(this),
            parent = that.closest('.collapsible'),
            parentId = parent.attr('id');

        $('.toc a[href="#' + parentId + '"]').focus();
      });

      //Button to open all collapsibles
      $('.open-collapsibles').on('click', function(e) {

        if(!$('html').hasClass('disable-collapsible')){

          if($(this).is('.open')) {
            //Close all
            $('.collapsible').removeClass('open');

            $(this).removeClass('open');
          }else {
            //Open all
            $('.collapsible').addClass('open');

            $(this).addClass('open');
          }

        }

        $(window).resize(); //Trigger needed for TOC to calculate new positions

      });

      //TODO: should this be done trough CSS, not js? open/collapse toggle is basically just class changes
      /*if($('html').hasClass('disable-collapsible')){
        $('.collapsible').addClass('open');
      }*/

    })();

    /**
     * Table of contents, aka TOC
     */
    (function() {
      var $toc = $('.toc');

      if(!$toc.length){ return; }

      var $article = $('main > article'), //Article
          $summary = $('.header .summary', $article), //Article summary
          $sections = $('section.collapsible, section.divider', $article), //Article sections
          $content = $toc.find('.contents'), // TOC: Bottom menu section (fixed)
          $list = $content.find('ul'); // TOC: List to append the links in


      var html = '', //TOC html containing links to summary and sections, optionally also subtitles that are not visible in body text
          index = 0; //Numeric index count for TOC items, subtitles do not have numbers and are excluded

      // Hide link list unless there's 2 or more sections
      if($sections.length < 2) $content.hide();

      //Create summary link, if the summary actually contains some content
      if($summary.length && $.trim($summary.text()) !== '') {
        var id = $summary.attr('id'),
            title = $summary.data('title');

        html += '' +
          '<li class="divider">' +
            '<a class="divider scroll-to" href="#'+id+'">'+title+'</a>' +
          '</li>';
      }

      /**
       * Create TOC links for each article section,
       * using first H2 element at the title.
       * Note: The split into sections is done by 'Create collapsibles' code block on runtime
       */
      $sections.each(function(){
        var $sect = $(this),
            title = $sect.find('h2').first().text(),
            $subHeadings = $sect.find('h3.toc-heading'),
            id = $sect.attr('id');

        if($sect.is('.divider')) {
          id = $sect.data('target');
          //Create divider title to TOC title
          html += '' +
            '<li class="divider">' +
              '<a class="divider scroll-to" href="#' + id + '">' + title + '</a>' +
            '</li>';
        }else {
          //Create link to collapsible section
          var indexPrefix = '';

          index++;

          //if(index < 10) indexPrefix = '0';

          html += '' +
            '<li>' +
              '<a class="scroll-to" href="#'+id+'">' +
                '<span class="index">'+indexPrefix+index+'</span>' +
                '<span class="name">'+title+'</span>' +
              '</a>' +
            '</li>';

          //Create link to collapsible sub headings (h3.toc-heading)
          $subHeadings.each(function(){
            var $subHeading = $(this),
                id = $subHeading.attr('id'),
                title = $subHeading.text();

            html += '' +
              '<li>' +
                '<a class="scroll-to sub-link" href="#'+id+'">' +
                  '<span class="name">'+title+'</span>' +
                '</a>' +
              '</li>';
          })
        }
      });

      //Insert list html to list container
      $list.html(html);

      //Sticky
      $list.stick_in_parent({
        offset_top: $('nav.primary .desktop').height(),
        parent: $article,
        sticky_class: 'is-stuck'
      });

      //TODO: redo this stuff below (look into foundation grid push&pull for a more css based solution)

      // Max (target) and min distance between TOC-menu and article text
      var _maxDistance = 100,
          _minDistance = 10;

      var $push = $('.toc-push'), // All columns to the right of the menu
          $body = $('main > article .body-content'); //Article text content

      /**
       * Adjust article content and positioning to keep
       * The menu visible on smaller screens
       */
      function adjustTocPosition() {
        /**
         * Reset all properties to natural state
         * as a quick and dirty way to avoid
         * side-effects from previously set styles
         */
        $toc.css({left: ''});
        $push.css({marginLeft: '', width: ''});

        if($toc.is(':visible')){

          var windowWidth = $(window).width(),
              tocWidth = $toc.width(),
              bodyX = $body.offset().left,
              extraSpace = bodyX - tocWidth,
              prefaceTop = ($('.preface').length ? $('.preface').offset().top - $('main .header').offset().top : $('main .body').css('padding-top'));

          if((extraSpace - _maxDistance) > 0){
            $toc.css({left: extraSpace - _maxDistance});
            $push.css({marginLeft: '', width: ''});
          }else if(extraSpace - _minDistance > 0) {
            $toc.css({left: 0});
            $push.css({marginLeft: '', width: ''});
          }else{
            $toc.css({left: 0});
            var pushWidth = (windowWidth - tocWidth - _minDistance);
            // Clamp maximum width
            if(pushWidth > 900) pushWidth = 900;
            $push.css({
              marginLeft: tocWidth + _minDistance,
              width: pushWidth
            });
          }

          $toc.css({top: prefaceTop});

          $(document.body).trigger('sticky_kit:recalc');

        }
      }

      var $collapsibles = $sections.filter('.collapsible'),
          $subHeadings = $collapsibles.find('h3.toc-heading'),
          $tocAnchorsUnOrdered = $collapsibles.add($subHeadings);

      //Temporarily open collapsibles to get correct offset top values for sub headings
      $collapsibles.addClass('open');

      // Sort TOC anchors by offset top
      var $tocAnchors = $($tocAnchorsUnOrdered.toArray().sort(function(a, b){
        return $(a).offset().top - $(b).offset().top;
      }));

      //Close temporarily opened collapsibles
      $collapsibles.removeClass('open');


      /**
       * Higlights the current toc item (aka the section/sub heading that has touched top of browser)
       */
      function tocHilight() {
        var sTop = $(window).scrollTop(); // + $('nav.primary .desktop').height();

        function getNextVisible($els, i){
          var $next = $els.eq(i+1);
          if($next.length && !$next.is(':visible')){
            return getNextVisible($els, i+2);
          }
          return $next;
        }

        $tocAnchors.each(function(i, tocAnchor) {
          var $s = $(tocAnchor),
              id = $s.attr('id'),
              $n = getNextVisible($tocAnchors, i);

          if ($s.is(':visible') && ($s.offset().top < sTop && ($n.length === 0 || $n.offset().top > sTop))) {
            $('.toc a[href="#' + id + '"]').parent().addClass('current');
            //TODO: article mobile header
          }else {
            $('.toc a[href="#' + id + '"]').parent().removeClass('current');
            //TODO: article mobile header
          }
        });
      }

      //Run once on load
      adjustTocPosition();

      $(window).on('scroll', function(e) {
        tocHilight();
      });

      $(window).on('resize', function(e) {
        adjustTocPosition();
      });
    })();


    /**
     * Related articles floating box
     */
    (function() {

      var related = $('.related-articles');

      if(!related.length) { return; }

      $('.close', related).on('click', function(e){
        e.preventDefault();
        $(this).closest('.related-articles').fadeOut('fast');
      });

      $(window).on('scroll', function(e) {
        var winTop = $(window).scrollTop(),
            winBottom = winTop + $(window).height(),
            asideTop = $('.asides').offset().top;

        if(winBottom > asideTop){
          related.removeClass('floating');
        }else{
          related.addClass('floating');
        }
      });
    })();

    /**
     * References
     */
    $(function(){
      var references = $('mark.reference'),
          referenceList = $('.references ol');

      if(references.length) {
        $.each(references, function(i, reference) {
          var text = $(reference).html().replace(/[\[\]]/g, ''), // eslint-disable-line
              //Added page id to ensure specificity
              linkId = PAGE_ID + '-reference-link-' + (i+1),
              textId = PAGE_ID + '-reference-text-' + (i+1),
              listItem = [
                '<li id="' + textId + '">',
                text,
                ' <a class="scroll-to" href="#' + linkId + '">↑</a>',
                '</li>'].join('');

          //Replace text with reference number & link
          $(reference).html('<a class="scroll-to" id="' + linkId + '" href="#' + textId + '">[' + (i+1) + ']</a>');

          referenceList.append(listItem);
        });

        $('.references').show();
        $(window).resize(); //Trigger needed for TOC to calculate new positions
      }
    });

    /**
     * Toggle collapsible form
     */
    (function(){
      var $form = $('.collapsible-form'),
          $toggle = $form.find('.toggle-form');

      $toggle.on('click', function(e){
        e.preventDefault();
        $form.toggleClass('open');
        $(window).resize(); //Trigger needed for TOC to calculate new positions
      });

      //Show contact form immediately if it contains validation errors
      $('.stage-form.stage-error').each(function(i, form) {
        var formEl = $(form);

        formEl.closest('.collapsible-form').addClass('open');

        //$(window).scrollTop(formEl.offset().top); //Useless, Slick slider scrolls to top...
      });
    }());

    /**
     * Toggle infoboxes.
     */
    (function() {
      $(document).on('click', '.infobox__header', function(e){
        e.preventDefault();
        var $button = $(this);
        var $target = $('#' + $button.attr('aria-controls'))
        var isOpen = $button.attr('aria-expanded') === 'true';
        if (isOpen) {
          $target.slideUp(300, function() {
            $button.attr('aria-expanded', 'false');
          });
        }
        else {
          $target.slideDown(300, function() {
            $button.attr('aria-expanded', 'true');
          });
        }
      });
    })();
  }
};
